export class WavesError extends Error {
  isWavesError: boolean

  constructor(message: string) {
    super(message)
    this.isWavesError = true
  }
}

export class WavesUserCancel extends WavesError {
  isUserCancel: boolean

  constructor() {
    super("User cancelled")
    this.isUserCancel = true
  }
}
